module.exports = __webpack_public_path__ + "static/media/rocks.6449b1f8.jpg";